// extracted by mini-css-extract-plugin
export default {"sectionContent":"SectionContent_sectionContent__4Wfn6","resizer":"SectionContent_resizer__onsJA","resizingContent":"SectionContent_resizingContent__Nn+3S"};